<template>

    <div v-if="success">
        <div class="py-12">
            <div>
                <i class="fas fa-check-circle text-6xl text-success"></i>
            </div>
            <div class="text-xl mt-5">
                Success!
            </div>
            <div class="style-body mt-5">
                <p class="mb-2">
                    We’ve sent you an email with instructions on how to reset your password.
                </p>
                <div class="mt-8">
                    <router-link
                            :to="{ name: 'signIn' }"
                            class="text-red hover:text-red-hover font-light underline cursor-pointer">
                        Go to Login
                    </router-link>
                </div>
            </div>
        </div>
    </div>

    <form v-else  class="form" @submit.prevent="formSubmit" ref='form' >
        <div v-if="errors.message" class="bg-red text-white mb-5 px-3 py-2 rounded ">
            {{ errors.message }}
        </div>

        <div class="input-container input-container--floating relative h-12 mb-5 "
             :class="{empty: !email, error: submittedOnce && errors.email}">
            <input
                    id="email"
                    type="email"
                    v-model="email"
                    class="h-full w-full border-gray-300 px-2 transition-all border-blue-gray rounded text-blue"
            />
            <label for="email" class="absolute left-2 transition-all px-1 text-blue-gray">
                Enter your email
            </label>
        </div>

        <div class="mt-10 flex flex-col md:flex-row items-center ">
            <button type="submit" class="btn w-full md:w-auto">Reset Password</button>
            <router-link
                    :to="{ name: 'signIn' }"
                    class="mt-3 md:mt-0 md:ml-8 text-red hover:text-red-hover font-light underline cursor-pointer">
                Cancel Form
            </router-link>
        </div>
    </form>
</template>


<script charset="utf-8">

    import { values, join, get } from 'lodash';
    import Vuex from 'vuex';

    export default {

        data() {
            return {
                submittedOnce: false,
                email: "",
                success: false,
                errors: {
                    email: 'Email is required'
                }
            }
        },

        emits: ["submit-success"],
        watch: {
            email: {
                handler(newEmail){
                    this.errors.email = newEmail ? '' : 'Email is required';
                }
            }
        },

        methods: {
            ...Vuex.mapActions('profile', {
                triggerResetPassword: 'triggerResetPassword',
            }),
            formSubmit() {
                this.submittedOnce = true;

                // do not submit if form has errors
                if (join(values(this.errors), '')) {
                    return;
                }

                this.triggerResetPassword(this.email);
                this.success = true;
                this.$emit('submit-success');

            }
        },
    }
</script>
